import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { AppCard } from './app/app-card';
import dffIcon from './assets/img/dff/icon.png';
import dffImage from './assets/img/dff/image.png';
import effIcon from './assets/img/eff/icon.png';
import effImage from './assets/img/eff/image.png';
import pdfImage from './assets/img/pdf-tool/image.png';
import pdfIcon from './assets/img/pdf-tool/pdf-background@2x.png';
import spaceIcon from './assets/img/space-usage/icon.png';
import spaceImage from './assets/img/space-usage/image.png';
import { Toolbar } from './toolbar/toolbar-component';
import { userSelector } from './user/user-slice';

import './app.scss';
import { MainMenuComponent } from './menu/main-menu';

export const App: React.FC<{}> = () =>  {
  const user = useSelector(userSelector);

  useEffect(() => {
    document.title = 'Koofr EXP';
  }, []);

  return (
    <div className="app">
      {user &&
        <Toolbar className='no-box-shadow right'>
          <div className='l-toolbar__column'></div>
          <div className='l-toolbar__column stretch'></div>
          <div className='l-toolbar__column'>
            <MainMenuComponent/>
          </div>
        </Toolbar>
      }
      <div className="title">
          <a target='_blank' href="https://app.koofr.net" className="title-logo"></a>
          <h1>Get the most out of Koofr</h1>
          <h3>Expand your experience with Koofr and explore our additional EXP tools.</h3>
      </div>
      <div className="container app-cont">
        <div className="apps">
          <AppCard
            image={dffImage}
            icon={dffIcon}
            text="Duplicate file finder"
            description="Find and remove duplicate files inside your Koofr account with ease."
            linkTo="/dff/"
          />
          <AppCard
            image={spaceImage}
            icon={spaceIcon}
            text="Space usage"
            description="See which folders and files are taking most of your space."
            linkTo="/space-usage/"
          />
          <AppCard
            image={pdfImage}
            icon={pdfIcon}
            text="PDF Tool"
            description="Manage your PDF files saved in Koofr."
            linkTo="/pdf-tool/"
          />
          <AppCard
            image={effImage}
            icon={effIcon}
            text="Empty folder finder"
            description="Find and remove your empty folders."
            linkTo="/eff/"
          />
        </div>
      </div>
    </div>
  );
}
